export default "__VITE_ASSET__BlOi7ifa__"